/** @jsx createElement */
import { createElement } from '@snugjs/html';
import { parseAdbContextCookie } from './parse-adb-context-cookie.js';
export function defineAdbContextService(options) {
    const { cookieName, resetPathname } = options;
    return {
        id: `adb-context-service`,
        create: () => {
            const adbContextCookie = parseAdbContextCookie(cookieName);
            // https://web.dev/bfcache/#update-stale-or-sensitive-data-after-bfcache-restore
            window.addEventListener(`pageshow`, (event) => {
                var _a;
                if (event.persisted &&
                    (adbContextCookie === null || adbContextCookie === void 0 ? void 0 : adbContextCookie.key) !== ((_a = parseAdbContextCookie(cookieName)) === null || _a === void 0 ? void 0 : _a.key)) {
                    location.reload();
                }
            });
            const resetAdbContext = () => {
                const { pathname, search, hash } = document.location;
                const formElement = (createElement("form", { action: resetPathname, method: "POST" },
                    createElement("input", { name: "redirectPath", type: "hidden", value: `${pathname}${search}${hash}` })));
                document.body.appendChild(formElement);
                formElement.submit();
                formElement.remove();
            };
            return {
                '1.0.0': () => {
                    return {
                        featureService: {
                            isAdbContextSet: Boolean(adbContextCookie),
                            resetAdbContext,
                        },
                    };
                },
                '2.0.0': () => {
                    return {
                        featureService: {
                            adbContext: adbContextCookie === null || adbContextCookie === void 0 ? void 0 : adbContextCookie.adbContext,
                            resetAdbContext,
                        },
                    };
                },
            };
        },
    };
}
//# sourceMappingURL=index.js.map